(ns rothko.theme.wandi.button
  (:refer-clojure :exclude [rem])
  (:require [garden.color :refer [darken lighten]]
            [garden.units :refer [rem]]
            [rothko.theme.sandi.colours :refer [colours]]))

(def orange (:green colours))
(def white (:white colours))

(def default
  {:border-style :solid
   :border-color orange
   :border-width (rem 0.2)
   :fill :currentColor})

(def main
  {:primary
   (merge
    default
    {:background-color orange
     :background-color--disabled (lighten orange 15)
     :background-color--hover (lighten orange 5)
     :border-color--disabled (lighten orange 15)
     :border-color--hover (lighten orange 5)
     :color white})

   :secondary
   (merge
    default
    {:background-color :transparent
     :background-color--hover (merge orange {:alpha 0.1})
     :background-color--disabled :transparent
     :border-color--disabled (lighten orange 15)
     :color orange
     :color--disabled (lighten orange 15)})

   :link
   {:padding 0
    :min-height 0
    :min-width 0
    :font-size :inherit
    :color--hover (darken orange 15)
    :color--disabled (lighten orange 15)}

   :invisible
   {:padding 0
    :min-height 0
    :min-width 0
    :font-size :inherit
    :outline :none}

   :no-outline
   {:outline :none}})
